<template>
  <div>
    <v-card class="mb-4"
      ><v-card-title>
        {{ $moment(month).format("MMMM YYYY") }}
      </v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item-group>
            <v-list-item
              v-for="(item, index) in filtreParcoursEffectif()"
              :key="index"
              class="row-pointer"
            >
              <v-list-item-content
                class="green px-4 white--text rounded my-1"
                v-if="item.checked && item.month == month"
                @click="gotoDetailsParcoursEffectif2(campagne, month, item)"
              >
                <v-list-item-title>  {{ item.ll_parcours }}</v-list-item-title>
                <v-spacer></v-spacer>
              </v-list-item-content>

              <v-list-item-content
                v-else
                @click.stop="creerParcoursEffectif(campagne, month, item)"
              >
                <v-list-item-title> {{ item.ll_parcours }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action v-if="item.checked && item.month == month">
                <v-btn
                  v-if="
                    user.role === 'regionalFull' ||
                    user.role === 'regionalReadOnly'
                  "
                  icon
                  @click="deleteParcoursEffectif(campagne, month, item)"
                >
                  <v-icon color="red lighten-1">mdi-trash-can-outline</v-icon>
                </v-btn>
              </v-list-item-action>
              <v-list-item-action v-else>
                <v-btn
                  icon
                  @click.stop="creerParcoursEffectif(campagne, month, item)"
                >
                  <v-icon color="grey lighten-1"
                    >mdi-plus-circle-outline</v-icon
                  >
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  props: {
    groupe: {
      type: Object,
      required: true,
    },
    campagne: {
      type: Object,
      required: true,
    },
    month: {
      type: String,
      required: true,
    },
    projet: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapState({
      //projetSelected: (state) => state.Auth.projetSelected,
      user: (state) => state.Auth.user,
      isSuperviseur: (state) => state.Auth.isSuperviseur,
      ParcoursEffectif(state) {
        return _.filter(state.ParcoursEffectif.ParcoursEffectif, {
          groupes_id_groupe: this.groupe.id,
        });
      },
      Acts: (state) => state.Activites.Activites,
      Activites(state) {
        return _.filter(state.Activites.Activites, {
          programmes_id_programme: this.projet.id,
        });
      },
    }),
  },
  methods: {
    creerParcoursEffectif(campagne, month, parcours) {
      let self = this;
      this.$confirm(
        "Voulez vous créer une activité de <strong>" +
          parcours.ll_parcours +
          "</strong> pour le mois de " +
          this.$moment(month).format("MMM YYYY") +
          "?"
      ).then((res) => {
        if (res) {
          let uuid = this.$uuid.v4();
          const FieldValue = this.$firebase.firestore.FieldValue;
          const groupe = this.groupe;
          var insert = {
            id_district: groupe.id_district,
            description_parcours: parcours.description_parcours,
            id_bailleur: campagne.bailleurs_id_bailleur,
            abbr_parcours: parcours.abbr_parcours,
            id_responsable: groupe.responsable,
            nom_groupe: groupe.nom_groupe,
            abbr_bailleur: campagne.abbr_bailleur,
            ll_programme: campagne.ll_programme,
            latitude: groupe.latitude,
            programmes_id_programme: campagne.programme_id_programme,
            date_fin: "0000-00-00 00:00:00",
            ll_region: groupe.ll_region,
            ll_fokontany: groupe.ll_fokontany,
            ll_commune: groupe.ll_commune,
            longitude: groupe.longitude,
            id_region: groupe.id_region,
            ll_parcours: parcours.ll_parcours,
            ll_bailleur: campagne.ll_bailleur,
            village: groupe.village,
            date_debut: month + " 01:00:00",
            ll_district: groupe.ll_district,
            ll_parcours_effectif: campagne.ll_campagne,
            id_parcours_effectif: campagne.id,
            ll_theme: parcours.ll_theme,
            parcours_id_parcours: parcours.id,
            code_fokontany: groupe.code_fokontany,
            nom_responsable: groupe.nom_responsable,
            groupes_id_groupe: this.groupe.id,
            ll_mois: month,
            themes_id_theme: parcours.themes_id_theme,
            id_commune: groupe.id_commune,
            dateInsert: FieldValue.serverTimestamp(),
            id_inserted: uuid,
            id: uuid,
          };
          if (groupe.ll_province) {
            insert.ll_province = groupe.ll_province;
          }

          this.$firebase
            .firestore()
            .collection("parcours_effectif")
            .doc(uuid)
            .set(insert, { merge: true })
            .then(() => {
              console.log("ParcoursEffectif créée id: " + uuid);
            })
            .catch((error) => {
              console.log(error);
            });
          //for Offline
          this.$emit("resetComopent");
          this.$emit("insertOneParcoursEffectif", insert);
        }
      });
    },
    gotoDetailsParcoursEffectif2(campagne, month, parcours) {
      let self = this;
      let startOfMonth = this.$moment(month).startOf("month").format("x");
      let endOfMonth = this.$moment(month).endOf("month").format("x");
      let ParcoursEffectifSelectionne = [];
      this.$firebase
        .firestore()
        .collection("parcours_effectif")
        .where("groupes_id_groupe", "==", self.groupe.id)
        .where("ll_parcours_effectif", "==", campagne.ll_campagne)
        .where("parcours_id_parcours", "==", parcours.id)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            ParcoursEffectifSelectionne.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          var filtered = _.filter(ParcoursEffectifSelectionne, function (o) {
            o.yahoo = self.$moment(o.ll_mois).format("x");
            return o.yahoo >= startOfMonth && o.yahoo <= endOfMonth;
          });

          self.$router.push({
            path: `/groupes/detailsParcoursEffectif/${filtered[0].id}`,
          });
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    },
    filtreParcoursEffectif() {
      var id_parcours_effectif = this.campagne.id;

      var month = this.month;
      let self = this;
      let startOfMonth = this.$moment(month).startOf("month").format("x");
      let endOfMonth = this.$moment(month).endOf("month").format("x");

      var filtered = _.filter(this.ParcoursEffectif, function (o) {
        o.yahoo = self.$moment(o.ll_mois).format("x");
        return (
          o.id_parcours_effectif == id_parcours_effectif &&
          o.yahoo >= startOfMonth &&
          o.yahoo <= endOfMonth
        );
      });

      var listeParcoursEffectifs = [];
      var listeActivites = [];
      _.forEach(filtered, function (item, index) {
        listeParcoursEffectifs[index] = item.parcours_id_parcours;
      });

      _.forEach(this.Activites, function (item, index) {
        if (_.includes(listeParcoursEffectifs, item.id)) {
          item.checked = true;
          item.month = month;
        } else {
          item.checked = false;
          item.month = false;
        }

        listeActivites.push(item);
      });

      return listeActivites;
    },
    deleteParcoursEffectif(campagne, month, item) {
      let self = this;
      this.$confirm("Voulez vous effacer cette activité?").then((res) => {
        if (res) {
          this.$firebase
            .firestore()
            .collection("parcours_effectif")
            .where("ll_mois", "==", month)
            .where("id_parcours_effectif", "==", campagne.id)
            .where("parcours_id_parcours", "==", item.id)
            .where("groupes_id_groupe", "==", this.groupe.id)
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                doc.ref
                  .delete()
                  .then(() => {
                    console.log("Document successfully deleted!");
                    self.deletEtapeEffectiveEtFiches(doc.id);
                  })
                  .catch(function (error) {
                    console.error("Error removing document: ", error);
                  });
                self.$emit("resetComopent");
              });
            })
            .catch((error) => {
              console.log("Error getting documents: ", error);
            });
        }
      });
    },
    deletEtapeEffectiveEtFiches(idParcoursEffectif) {
      let collectionRef = this.$firebase
        .firestore()
        .collection("etapes_effectives");

      collectionRef
        .where(
          "parcours_effectif_id_parcours_effectif",
          "==",
          idParcoursEffectif
        )
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            doc.ref
              .delete()
              .then(() => {
                console.log("Document successfully deleted!");
              })
              .catch(function (error) {
                console.error("Error removing document: ", error);
              });
          });
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
        });

      //fiches
      let fichesRef = this.$firebase.firestore().collection("fiches");

      fichesRef
        .where(
          "parcours_effectif_id_parcours_effectifs",
          "==",
          idParcoursEffectif
        )
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            doc.ref
              .delete()
              .then(() => {
                console.log("Document successfully deleted!");
              })
              .catch(function (error) {
                console.error("Error removing document: ", error);
              });
          });
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.row-pointer:hover {
  cursor: pointer;
}
</style>
